export const CRYPTO_SALT_BASE64_MIN_LENGTH = 32;
export const CRYPTO_SALT_BASE64_MAX_LENGTH = 64;
export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "active";
    UserStatus["PENDING"] = "pending";
    UserStatus["INACTIVE"] = "inactive";
})(UserStatus || (UserStatus = {}));
